import React, { forwardRef, useEffect, useRef, useState } from 'react'
// eslint-disable-next-line no-restricted-imports
import { InputNumber } from 'antd'
import type { InputNumberProps as AntdInputNumberProps } from 'antd'
import styles from './index.less'

export interface GylInputNumberProps extends AntdInputNumberProps {
    /** 输入框前缀，antd 4.x 原生 InputNumber 不支持，由本组件补齐 */
    prefix?: React.ReactNode
}

export type { GylInputNumberProps as InputNumberProps }

const INITIAL_PREFIX_WIDTH = 0

const GylInputNumber = forwardRef<unknown, GylInputNumberProps>(({ prefix, ...restProps }, ref) => {
    const prefixRef = useRef<HTMLSpanElement>(null)
    const [prefixWidth, setPrefixWidth] = useState(INITIAL_PREFIX_WIDTH)

    useEffect(() => {
        if (prefixRef.current) {
            setPrefixWidth(prefixRef.current.offsetWidth)
        }
    }, [prefix])

    if (!prefix) {
        return <InputNumber ref={ref} {...restProps} />
    }

    return (
        <div className={styles.prefixWrapper} style={{ '--prefix-width': `${prefixWidth}px` } as React.CSSProperties}>
            <span ref={prefixRef} className={styles.prefix}>
                {prefix}
            </span>
            <InputNumber ref={ref} {...restProps} />
        </div>
    )
})

export default GylInputNumber
